export type ElevationValue =
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24

// inspired by: https://ethercreative.github.io/react-native-shadow-generator/
const elevationShadowMap: Map<ElevationValue, string> = new Map([
    [1, '0 1px 1px rgba(0, 0, 0, 0.18)'],
    [2, '0 1px 1.41px rgba(0, 0, 0, 0.2)'],
    [3, '0 1px 2.22px rgba(0, 0, 0, 0.22)'],
    [4, '0 2px 2.62px rgba(0, 0, 0, 0.23)'],
    [5, '0 2px 3.84px rgba(0, 0, 0, 0.25)'],
    [6, '0 3px 4.65px rgba(0, 0, 0, 0.27)'],
    [7, '0 3px 4.65px rgba(0, 0, 0, 0.29)'],
    [8, '0 4px 4.65px rgba(0, 0, 0, 0.30)'],
    [9, '0 4px 5.46px rgba(0, 0, 0, 0.32)'],
    [10, '0 5px 6.27px rgba(0, 0, 0, 0.34)'],
    [11, '0 5px 6.68px rgba(0, 0, 0, 0.36)'],
    [12, '0 6px 7.49px rgba(0, 0, 0, 0.37)'],
    [13, '0 6px 8.3px rgba(0, 0, 0, 0.39)'],
    [14, '0 7px 9.11px rgba(0, 0, 0, 0.41)'],
    [15, '0 7px 9.51px rgba(0, 0, 0, 0.43)'],
    [16, '0 8px 10.32px rgba(0, 0, 0, 0.44)'],
    [17, '0 8px 11.14px rgba(0, 0, 0, 0.46)'],
    [18, '0 9px 11.95px rgba(0, 0, 0, 0.48)'],
    [19, '0 9px 12.35px rgba(0, 0, 0, 0.50)'],
    [20, '0 10px 13.16px rgba(0, 0, 0, 0.51)'],
    [21, '0 10px 13.97px rgba(0, 0, 0, 0.53)'],
    [22, '0 11px 14.78px rgba(0, 0, 0, 0.55)'],
    [23, '0 11px 15.19px rgba(0, 0, 0, 0.57)'],
    [24, '0 12px 16px rgba(0, 0, 0, 0.58)'],
])

export const elevationToBoxShadow = (elevation: ElevationValue): string | undefined => {
    return elevationShadowMap.get(elevation)
}
